<template>
  <v-container fluid grid-list-md>
    <!-- intro ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->

    <CorePageIntro>
      <template slot="content">
        The purpose of this report is to compare the Sustaine&trade;
        recommendations to what actually happened at the location.
      </template>
    </CorePageIntro>

    <!-- date picker ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->

    <v-layout row wrap align-start justify-center>
      <v-flex
        xs12
        sm12
        class="text-xs-center text-sm-center text-md-right text-justify-end"
      >
        <h4 class="body-2 font-weight-bold">
          Change Time:
                <date-picker
                  v-model="rundate"
                  :not-after="rundateUpper"
                  :minute-step="15"
                  clearable
                  confirm
                  width="175"
                  lang="en"
                  type="datetime"
                  format="YYYY-MM-DD HH:mm">
              </date-picker>
              <v-btn @click="fetch()" class="mx-2" fab dark small color="orange darken-3">
                  <v-icon dark>sync</v-icon>
              </v-btn>
        </h4>
      </v-flex>
    </v-layout>

    <!-- chart ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->

    <PerformanceChart
      v-if="loaded"
      :intervals="rawData.intervals"
      :calculated="calculatedAt"
      :intervalLength="rawData.interval_length_seconds"
      :rampUpMinutes="60"
      :rampDownMinutes="30"
      :key="`chart-${componentKey}`"
    ></PerformanceChart>

    <!-- metrics (panel) ~*~*~*~*~*~*~*~*~*~*~* -->

    <PerformanceStatPanel
      v-if="loaded"
      :intervals="rawData.intervals"
      :key="`panel-${componentKey}`"
    ></PerformanceStatPanel>

    <!-- table ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->

    <PerformanceTable
      v-if="loaded"
      :intervals="rawData.intervals"
      :key="`table-${componentKey}`"
    ></PerformanceTable>
  </v-container>
</template>

<script>
import MockDataService from '@/services/MockDataService'
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  name: 'Performance',
  data() {
    return {
      loaded: false,
      mockId: false,
      rundate: '',
      rundateUpper: '',
      rawData: [],
      calculatedAt: '',
      componentKey: 0
    }
  },
  computed: {
    ...mapGetters(['getFacilityId', 'getFacilityTimezone'])
  },
  watch: {
    rawData() {
      this.componentKey += 1
    }
  },
  created() {
    // set upper date range bound
    this.$root.loading = true
    this.rundateUpper = moment()
      .subtract(1, 'days')
      .hour(23)
      .minute(45)
      .second(0)
      .toDate()
    this.inputs(this.$route.params.x)
    this.fetch()
    this.$root.loading = false
  },
  beforeRouteUpdate(to, from, next) {
    this.$root.loading = true
    this.rundateUpper = moment()
      .subtract(1, 'days')
      .hour(23)
      .minute(45)
      .second(0)
      .toDate()
    this.inputs(to.params.x)
    this.fetch()
    this.$root.loading = false
    next()
  },
  // == Methods
  methods: {
    inputs(params) {
      if (params != null) {
        this.mockId = parseInt(params)
      }
    },
    fetch() {
      this.loaded = false
      this.rawData = []
      this.rawData = MockDataService.getPerformanceData(parseInt(this.mockId))
      this.date = this.rawData.report_date
      this.rundate = 
        moment(this.rawData.calculated_at_utc)
        .format('YYYY-MM-DD HH:mm:ss')
      this.calculatedAt = 
        moment(this.rawData.calculated_at_utc)
        .format('YYYY-MM-DD HH:mm:ss')
      this.loaded = true
    }
  }
}
</script>
